import { createContext, useContext } from 'react';
import type { SceneManifest } from './manifest';
import type { StylePack } from './style-packs';

interface SceneContextValue {
  manifest: SceneManifest;
  pack: StylePack;
}

const SceneContext = createContext<SceneContextValue | null>(null);

export function SceneProvider({
  value,
  children,
}: {
  value: SceneContextValue;
  children: React.ReactNode;
}) {
  return <SceneContext.Provider value={value}>{children}</SceneContext.Provider>;
}

export function useScene(): SceneContextValue {
  const ctx = useContext(SceneContext);
  if (!ctx) throw new Error('useScene must be used inside <SceneProvider>');
  return ctx;
}
